import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'app-dialog-confirm',
    templateUrl: './dialog-confirm.component.html',
    styleUrls: ['./dialog-confirm.component.css']
})
export class DialogConfirmComponent implements OnInit {

    delete = false;
    message = 'Da li želite da izbrišete task?';


    constructor(public dialogRef: MatDialogRef<DialogConfirmComponent>,
                @Inject(MAT_DIALOG_DATA) public dialogData: { message: string }) {
    }

    ngOnInit(): void {

        if (this.dialogData) {
            this.message = this.dialogData.message;
        }
    }

    deleteTask() {
        this.delete = true;
        this.dialogRef.close(this.delete);
    }

    closeDialog() {
        this.dialogRef.close(this.delete);
    }
}
